import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin, faFacebook } from "@fortawesome/free-brands-svg-icons"
import './Footer.css';
class Footer extends Component {
    render() {
        return <footer style={{ textAlign: 'center' }}>
            <h2 className="jsectionHead">MD. Jayeen Bin Alam</h2>
            <div className="footer-icons">
                <a href="https://github.com/jayeen28" target="_blank" rel="noreferrer" aria-label="GitHub">
                    <FontAwesomeIcon icon={faGithub} />
                </a>
                <a href="https://www.linkedin.com/in/jayeen28/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                    <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a href="https://facebook.com/jayeen28" target="_blank" rel="noreferrer" aria-label="Facebook">
                    <FontAwesomeIcon icon={faFacebook} />
                </a>
            </div>
            <p className="copyright">© {new Date().getFullYear()} MD. Jayeen Bin Alam. All rights reserved.</p>
        </footer>;
    }
};

export default Footer;